<div class="main-container">
  <div class="app-container">
    @if (isTranslationReady()) {
      @if (hasRightToShowNavBar()) {
        <pvmo-nav-bar class="nav-bar-content" (opacity)="setOpacity($event)"></pvmo-nav-bar>
      }
      <div [ngClass]="{ 'app-content': true, opacity: opacity, 'padding-with-navbar': hasRightToShowNavBar() }">
        <pvmo-header></pvmo-header>
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
